// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + "settings-vendors" + "-" + "1f9a92758fbd6a24" + ".js"
}